"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIsMobileOffice = void 0;
var _react = require("react");
const useIsMobileOffice = () => {
  const [isMobileOffice, setIsMobileOffice] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    const mobileOfficeClassInHtml = 'page-mypages';
    if (document.getElementsByTagName('html')[0]?.classList.contains(mobileOfficeClassInHtml)) {
      setIsMobileOffice(true);
    }
  }, []);
  return isMobileOffice;
};
exports.useIsMobileOffice = useIsMobileOffice;